import React from 'react';
import { GoldBow } from './GoldBow';

/**
 * Section divider: a small centered gold bow with a thin camel hairline
 * running left and right of it.
 */
export function SectionDivider({
  tone = 'light'
}: {
  tone?: 'light' | 'warm';
}) {
  return <div aria-hidden="true" className={`w-full ${tone === 'warm' ? 'bg-offwhite' : 'bg-white'}`} data-id="element-245" data-mp="3e2812qsn6awc">
      <div className="mx-auto flex w-full max-w-7xl items-center gap-5 px-4 py-8 sm:px-6 md:py-10" data-id="element-246" data-mp="397astm36s5ki">
        <span className="h-px flex-1 bg-camel/45" data-id="element-247" data-mp="347pv1ezr639d" />
        <GoldBow className="h-6 w-8 shrink-0" data-id="element-248" data-mp="2ze3om4k6mvm0" />
        <span className="h-px flex-1 bg-camel/45" data-id="element-249" data-mp="2zdbs8rirgtuo" />
      </div>
    </div>;
}